import {
    Building2,
    Boxes,
    BriefcaseBusiness,
    UserRoundCog,
    Users,
    UserRound,
  } from "lucide-react";
  
  const stats = [
    {
      label: "Departments",
      value: 7,
      subLabel: "Total",
      icon: Building2,
      iconClass: "bg-blue-50 text-blue-500",
    },
    {
      label: "Functions",
      value: 31,
      subLabel: "Active",
      icon: Boxes,
      iconClass: "bg-emerald-50 text-emerald-500",
    },
    {
      label: "Roles",
      value: 54,
      subLabel: "Defined",
      icon: BriefcaseBusiness,
      iconClass: "bg-violet-50 text-violet-500",
    },
    {
      label: "Designations",
      value: 176,
      subLabel: "Generated",
      icon: UserRoundCog,
      iconClass: "bg-orange-50 text-orange-500",
    },
    {
      label: "Teams",
      value: 24,
      subLabel: "Active",
      icon: Users,
      iconClass: "bg-pink-50 text-pink-500",
    },
    {
      label: "Employees",
      value: 182,
      subLabel: "Total",
      icon: UserRound,
      iconClass: "bg-sky-50 text-sky-500",
    },
  ];
  
  const OrganizationStats = () => {
    return (
      <section className="px-6 py-5">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
          {stats.map((stat) => {
            const Icon = stat.icon;
  
            return (
              <div
                key={stat.label}
                className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition duration-200 hover:-translate-y-0.5 hover:border-theme-200 hover:shadow-md"
              >
                {/* Icon */}
                <div
                  className={`flex h-10 w-10 items-center justify-center rounded-lg ${stat.iconClass}`}
                >
                  <Icon size={20} strokeWidth={2} />
                </div>
  
                {/* Content */}
                <div className="mt-4">
                  <p className="text-xs font-medium text-slate-500">
                    {stat.label}
                  </p>
  
                  <div className="mt-1 flex items-end gap-2">
                    <span className="text-2xl font-semibold leading-7 text-slate-800">
                      {stat.value}
                    </span>
  
                    <span className="mb-0.5 text-[11px] font-medium text-slate-400">
                      {stat.subLabel}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  };
  
  export default OrganizationStats;